module.exports = __webpack_public_path__ + "img/icon_btn_perce.ac1a71d0.svg";